import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { Approve_RejectDecision, Languages, ServiceStatus, FormMode } from 'src/app/shared/models/enums.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import { EntranceRequestComponent } from 'src/app/front-user/services/small-units/entrance-request/entrance-request.component';
import { SmallUnitsAdminService } from '../shared/services/small-units.service.admin';
import { SmallUnitadminDTO } from '../shared/models/small-units-admin.model';
import { SmallUnitsServiceFE } from 'src/app/front-user/services/small-units/shared/services/small-units.service';
import { SmallUnitRequest } from 'src/app/front-user/services/small-units/shared/models/Small-Unit-Request.model';


@Component({
  selector: 'app-register-measurment',
  templateUrl: './register-measurment.component.html'
})


export class RegisterMeasurmentComponent implements OnInit {
  submitted = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest//= new BaseRequest();
  decision = Approve_RejectDecision;
  decisionKeys = Object.keys(this.decision);
  displayedLang: string;
  decisionValue: number;
  registerMeasurmentsForm: FormGroup;
  user: User = new User();
  agent: User = new User();
  smallunitRequestObj: SmallUnitRequest = new SmallUnitRequest();
  adminDecisionObject: SmallUnitadminDTO = new SmallUnitadminDTO();
  showRequest = false;
  agentId: string;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  isLoaded: boolean = false;
  isErrorMessage: boolean = false;
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  maxNetTonnage: number = 299.999;
  todayDate= new Date();
  @Input() public isShow: boolean = true;
  @ViewChild('EntranceRequest',{static: false}) EntranceRequest: EntranceRequestComponent;
  responseObj: ResponseObject = new ResponseObject();
  lockTaskErrorMessage: boolean = false;
  AuditorsList: [] = [];
  initialTransitFees: number = 0;
  initialTotalFees: number = 0;
  initialTotalFees_LE: number = 0;
  

  constructor(private formBuilder: FormBuilder, private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private route: ActivatedRoute, private router: Router,
    private translate: TranslateService,
    private SmallUnitServ: SmallUnitsServiceFE,
    private authenticationService: AuthenticationService, private alertService: AlertService,
    private SmallUnitAdminServ: SmallUnitsAdminService, private agentSrv: AgentService) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    //this.baseRequestId = this.route.snapshot.params.Id;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    } else {
      window.history.back();
    }

    this.user = this.globalSrv.user;

  }

  ngOnInit() {

    this.buildForm(null);
  }

  buildForm(decision) {
    this.registerMeasurmentsForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
    });
    if (decision == Approve_RejectDecision.Reject) {
      this.registerMeasurmentsForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        RejectReason: ['', [Validators.required]],
      });
    }
    else if (decision == Approve_RejectDecision.Approve) {
      this.registerMeasurmentsForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        Length: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
        Width: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
        Hight: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
        SCNT: ['', [Validators.required, Validators.pattern(this.numberRegex), Validators.max(this.maxNetTonnage)]],
        SCGT: ['', [Validators.required, Validators.pattern(this.numberRegex), Validators.max(this.maxNetTonnage)]],
        SDRRate: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
        SDRDate: ['', [Validators.required]],
        LocalEquiv: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
        AuditorId: ['', [Validators.required]],
      });
    }
  }
  changeDecision(value) {
    this.buildForm(value);
    this.registerMeasurmentsForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;
  }

  get f() {
    return this.registerMeasurmentsForm.controls;
  }

  getBaseRequest() {
    this.SmallUnitServ.get(this.baseRequestId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.smallunitRequestObj = this.responseObj.Data;
          this.requestStatus = this.smallunitRequestObj.StatusId;
          this.agentId = this.smallunitRequestObj.RequestorId;
          this.isLoaded = true;
          this.decisionValue = this.smallunitRequestObj.MeasActualActionId;
          this.getAuditorsList();
          if (history.state.data && history.state.data.isCompleted) {


            if (this.smallunitRequestObj.MeasActualActionId == Approve_RejectDecision.Reject) {
              //this.decisionValue = Approve_RejectDecision.Reject;
              this.buildForm(this.decisionValue);
              this.registerMeasurmentsForm.patchValue({
                Decision: Approve_RejectDecision.Reject,
                RejectReason: this.smallunitRequestObj.MeasActualRejectReason
              });
            }
            else {
              //this.decisionValue = Approve_RejectDecision.Approve;
              console.log(this.AuditorsList);
              this.buildForm(this.decisionValue);
              this.registerMeasurmentsForm.patchValue({
                Decision: Approve_RejectDecision.Approve,
                Length: this.smallunitRequestObj.ActualLength,
                Width: this.smallunitRequestObj.ActualWidth,
                Hight: this.smallunitRequestObj.ActualDepth,
                SCNT: this.smallunitRequestObj.ActualSCNT,
                SCGT: this.smallunitRequestObj.ActualSCGT,
                SDRRate: this.smallunitRequestObj.FinalSDR,
                SDRDate: this.smallunitRequestObj.InitialSDRDate,
                LocalEquiv: this.smallunitRequestObj.LocalEquiv,
                AuditorId: this.smallunitRequestObj.InvoiceAuditorName
              });
            }
            this.formMode = FormMode.Readonly;
            this.registerMeasurmentsForm.disable();
          }
          else if (this.requestStatus == ServiceStatus.SmallUnit_PendingMeasuringUnit) {
            this.formMode = FormMode.Add;
            this.registerMeasurmentsForm.enable();
          }
          else {
            this.formMode = FormMode.Readonly;
            this.buildForm(this.decisionValue);
            this.registerMeasurmentsForm.disable();
            this.registerMeasurmentsForm.patchValue({
              Decision: Approve_RejectDecision.Approve,
              Length: this.smallunitRequestObj.ActualLength,
              Width: this.smallunitRequestObj.ActualWidth,
              Hight: this.smallunitRequestObj.ActualDepth,
              SCNT: this.smallunitRequestObj.ActualSCNT,
              SCGT: this.smallunitRequestObj.ActualSCGT,
              SDRRate: this.smallunitRequestObj.FinalSDR,
              SDRDate: this.smallunitRequestObj.InitialSDRDate,
              LocalEquiv: this.smallunitRequestObj.LocalEquiv,
              AuditorId: this.smallunitRequestObj.InvoiceAuditorName
            });
          }
        }


        // if (this.requestStatus == ServiceStatus.PendingonMeasurementsOfficerReviewerApproval) {
        //   this.formMode = FormMode.Add;
        //   this.registerMeasurmentsForm.enable();

        // }
        // else

        // else {
        //   this.getFeesEstimation();
        //   this.formMode = FormMode.Readonly;
        //   this.registerMeasurmentsForm.disable();
        // }
      }
    )
  }

  getAuditorsList() {
    if (this.smallunitRequestObj.DirectionId == 2) { //Northbound
      var groupName = 'SCAServices_Measurement Officer_Suez';
    } else if (this.smallunitRequestObj.DirectionId == 3) { //Southbound
      var groupName = 'SCAServices_Measurement Officer';
    }
    this.SmallUnitServ.getAuditorsList(groupName).subscribe(
      (resObj: ResponseObject) => {
        if (resObj.Success) {
          this.AuditorsList = resObj.Data;
        }
      }
    )
  }

  calculateTransitFees() {
    if (this.registerMeasurmentsForm.controls.SDRRate.valid && this.registerMeasurmentsForm.controls.SCNT.valid) {
      let SDRRate = this.registerMeasurmentsForm.controls.SDRRate.value;
      if (SDRRate != "") {
        this.initialTransitFees = this.calculateInitialTransitFees(this.registerMeasurmentsForm.controls.SCNT.value, SDRRate);
        this.initialTotalFees = this.initialTransitFees; // No Services added yet.
        this.calculateTotalFeesLE();
      }
    }
  }

  calculateInitialTransitFees(actualNetTonnage: any, SDRRate: any) {
    return Number((5 * actualNetTonnage * SDRRate).toFixed(2));
  }

  calculateTotalFeesLE() {
    if (this.registerMeasurmentsForm.controls.LocalEquiv.valid) {
      let LocalEquiv = this.registerMeasurmentsForm.controls.LocalEquiv.value; 
      if (LocalEquiv != "") {
        this.initialTotalFees_LE = (this.initialTotalFees * LocalEquiv);
      }
    }
  }

  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.registerMeasurmentsForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    // this.adminDecisionObject = this.registerMeasurmentsForm.value;
    this.adminDecisionObject.AdminEmail = this.user.UserName;
    this.adminDecisionObject.Id = this.baseRequestId;
    this.adminDecisionObject.MeasActualActionId = this.registerMeasurmentsForm.controls.Decision.value;
    if (this.adminDecisionObject.MeasActualActionId == Approve_RejectDecision.Reject) {
      this.adminDecisionObject.MeasActualRejectReason = this.registerMeasurmentsForm.controls.RejectReason.value;
    }
    else if (this.adminDecisionObject.MeasActualActionId == Approve_RejectDecision.Approve) {
      this.adminDecisionObject.ActualLength = this.registerMeasurmentsForm.controls.Length.value;
      this.adminDecisionObject.ActualWidth = this.registerMeasurmentsForm.controls.Width.value;
      this.adminDecisionObject.ActualDepth = this.registerMeasurmentsForm.controls.Hight.value;
      this.adminDecisionObject.ActualSCNT = this.registerMeasurmentsForm.controls.SCNT.value;
      this.adminDecisionObject.ActualSCGT = this.registerMeasurmentsForm.controls.SCGT.value;
      this.adminDecisionObject.FinalSDR = this.registerMeasurmentsForm.controls.SDRRate.value;
      this.adminDecisionObject.InitialSDRDate = this.registerMeasurmentsForm.controls.SDRDate.value;
      this.adminDecisionObject.FinalTransitFeesValue = this.initialTransitFees;
      this.adminDecisionObject.FinalTotalFees = this.initialTotalFees;
      this.adminDecisionObject.LocalEquiv = this.registerMeasurmentsForm.controls.LocalEquiv.value;
      this.adminDecisionObject.TotalFeesLE = this.initialTotalFees_LE;
      this.adminDecisionObject.InvoiceAuditorName = this.registerMeasurmentsForm.controls.AuditorId.value;
    }

    this.SmallUnitAdminServ.AddMeasurementActualDecision(this.adminDecisionObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.registerMeasurmentsForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.'+data.ErrorMessages[0]), false);

            this.loading = false;
          }

        });
  }
  
}


